import { useState } from 'react'

import { contentTabs } from '@/configuration/pages/ConfigurationPage/CommunicationsConfiguration/EmailTemplates/EmailTemplateDetailConfiguration/ContentTabs/constants'

const useContentTab = () => {
  const [selectedContentTab, setSelectedContentTab] = useState(contentTabs.write)

  return { selectedContentTab, setSelectedContentTab }
}

export default useContentTab
